import "./TestOrderIcdCodesSelectionComponent.scss";
import HeadingComponent from "../../heading/headingComponent";
import SearchComponent from "../../search/SearchComponent";
import TabsWrapperComponent, {TabComponent, TabContentComponent, TabsComponent} from "../../tabs/tabsComponent";
import TableWrapperV2Component from "../../table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../../constants";
import React, {useCallback, useState} from "react";
import {ITableColumn} from "../../../models/table.model";
import CheckboxComponent from "../../core/checkbox/CheckboxComponent";
import CommonService from "../../../services/common.service";

interface TestOrderIcdCodesSelectionComponentProps {
    formikRef: any;
    currentStepIds: any;
}

const MODULE_NAME = 'icd-codes'

const ALL_ICD_CODES = "all_icd_codes";
const TEST_ICD_CODES = "test_icd_codes";


const TestOrderIcdCodesSelectionComponent = (props: TestOrderIcdCodesSelectionComponentProps) => {
    const {formikRef, currentStepIds} = props;

    const [currentTab, setCurrentTab] = useState<"all_icd_codes" | "test_icd_codes">(TEST_ICD_CODES);
    const [drawerTableFilter, setDrawerTableFilter] = useState({
        search: ""
    })

    const handleSelectDeselectIcd = useCallback((isChecked: boolean, icdCode: any) => {
        try {
            const currendIcdCodes = formikRef?.current?.values?.sampleDetails?.[currentStepIds?.index]?.sample?.[currentStepIds?.testIndex]?.icdCodes || []
            if (isChecked) {
                currendIcdCodes?.push(icdCode);
            } else {
                const icdID = icdCode?.id;
                currendIcdCodes?.splice(currendIcdCodes?.findIndex((item: any) => item?.id === icdID), 1);
            }
            formikRef?.current && formikRef?.current?.setFieldValue(`sampleDetails[${currentStepIds?.index}].sample[${currentStepIds?.testIndex}].icdCodes`, currendIcdCodes)
        } catch (error) {
            console.error("Error on select/deselect icd codes")
        }
    }, [currentStepIds,formikRef]);

    const handleClearAllIcdCode = useCallback(() => {
        try {
            formikRef?.current && formikRef?.current?.setFieldValue(`sampleDetails[${currentStepIds?.index}].sample[${currentStepIds?.testIndex}].icdCodes`, [])
            CommonService._communications.TableWrapperRefreshSubject.next({
                moduleName: MODULE_NAME
            });
        } catch (error) {
            console.error("Error while clear all icd code")
        }
    }, [currentStepIds,formikRef])

    const columns: ITableColumn[] = [
        {
            id: 'select',
            label: <></>,
            // hideInColumnPreferences: true,
            isDefaultColumn: true,
            fixed: "left",
            width: '50',
            content: (item: any) => {
                const selectIcdList = formikRef?.current?.values?.sampleDetails?.[currentStepIds?.index]?.sample?.[currentStepIds?.testIndex]?.icdCodes || []
                return <CheckboxComponent
                    name={"sample_select"}
                    size={"small"}
                    // disabled={sendOutApplicableSamples?.findIndex((sample: ISample) => sample.id === item.id) === -1}
                    disableRipple={true}
                    checked={selectIcdList?.findIndex((sample: any) => sample?.id === item?.id) > -1}
                    onUpdate={(isChecked: boolean) => {
                        handleSelectDeselectIcd(isChecked, item);
                    }}/>
            }
        },
        {
            id: "icdCode",
            label: "ICD Code",
            width: 100,
            isDefaultColumn: true, align: "center"
        },
        {
            id: "description",
            label: "Description",
            width: 300,
            isDefaultColumn: true, align: "left"
        },
    ]

    return (
        <div className="screen t-form-screen">
            <div className="drawer-sub-header horizontal-vertical-center-align">
                <HeadingComponent title={"Select ICD Code(s)"}/>
                <div className={'filters-clear-all-button'}
                     onClick={handleClearAllIcdCode}
                >
                    Clear all
                </div>
            </div>
            <div className="t-form t-form-drawer">
                <div className="t-form-controls-wrapper">
                    <SearchComponent label={""} placeholder={"Search"} value={drawerTableFilter.search}
                                     onChange={(e) => setDrawerTableFilter((prev) => {
                                         return {
                                             ...prev,
                                             search: e
                                         }
                                     })}/>
                    <div className="table-list-container">
                        <TabsWrapperComponent>
                            <TabsComponent
                                value={currentTab}
                                allowScrollButtonsMobile={false}
                                onUpdate={(e: any, v: any) => {
                                    setCurrentTab(v);
                                }}
                            >
                                <TabComponent label={"Test ICD Codes"} value={TEST_ICD_CODES}/>
                                <TabComponent label={"All ICD Codes"} value={ALL_ICD_CODES}/>
                            </TabsComponent>
                            <TabContentComponent value={TEST_ICD_CODES} selectedTab={currentTab}>
                                <TableWrapperV2Component
                                    isPaginated={false}
                                    columns={columns}
                                    url={APIConfig.GET_FILTERED_ICD_CODE_LIST_TABLE.URL(currentStepIds?.testId)}
                                    method={APIConfig.GET_FILTERED_ICD_CODE_LIST_TABLE.METHOD}
                                    extraPayload={drawerTableFilter}
                                    isColumnFilterVisible={false}
                                    moduleName={MODULE_NAME}
                                    // onDataLoad={(data: any) => setData(data)}
                                />
                            </TabContentComponent>
                            <TabContentComponent value={ALL_ICD_CODES} selectedTab={currentTab}>
                                <TableWrapperV2Component
                                    isPaginated={true}
                                    columns={columns}
                                    url={APIConfig.GET_ICD_CODE_LIST_TABLE.URL}
                                    method={APIConfig.GET_ICD_CODE_LIST_TABLE.METHOD}
                                    extraPayload={drawerTableFilter}
                                    isColumnFilterVisible={false}
                                    moduleName={MODULE_NAME}
                                    // onDataLoad={(data: any) => setData(data)}
                                />
                            </TabContentComponent>
                        </TabsWrapperComponent>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default TestOrderIcdCodesSelectionComponent;
